module.exports = __webpack_public_path__ + "static/media/AB_S2.692be7bb.jpg";